import {
  lazy,
  type ComponentProps,
  type ComponentType,
  type LazyExoticComponent,
} from "react";

export function withCompass<C extends ComponentType<any>>(
  importFn: () => Promise<{ default: C }>
): LazyExoticComponent<C> {
  return lazy(async () => {
    const [{ default: Component }, { CompassProvider }] = await Promise.all([
      importFn(),
      import("../../contexts/CompassContext"),
    ]);
    const Wrapped = (props: ComponentProps<C>) => (
      <CompassProvider>
        <Component {...props} />
      </CompassProvider>
    );
    return { default: Wrapped as unknown as C };
  }) as LazyExoticComponent<C>;
}
